import React from 'react';
import {config} from 'helpers';
import {Formatted, Video} from 'components';

export function Intro() {
  return (
    <Formatted className="medium-spacing">
      <Video.Video src={config.videos.clarity.intro} />
      <p className="medium-spacing">Everyone needs to begin somewhere, so we created Clarity Wizard, a free, no-risk way to get going on the path to improving your life. Clarity Wizard is designed specifically for people who are wondering if there is more to life and how they can shake things up. By working with Clarity Wizard, you will begin to see clearly how you feel about your current life and you will start taking active steps to change the things you are no longer happy with.</p>
      <h5>Foundation</h5>
      <p>This educational section walks you through the fundamentals of personal success and the basic concepts that are at the core of making lasting changes in life.</p>
      <h5>Reality Check</h5>
      <p>This tool gives you a snapshot of where you stand right now in specific areas of your life. By breaking down the different aspects that make up your whole life, you can see where it makes sense to put energy and seek change.</p>
      <h5>Targeted Inquiries</h5>
      <p>In this section, you take what you discovered in the Reality Check and choose an area of your life where you would like to see change. There are specific and targeted questions to help you focus on eight different parts of your life and then begin to make productive changes.</p>
    </Formatted>
  );
}
